exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".SocialLink__social-icon__1HaNw {\n  display: inline-block;\n  height: 2.85em;\n  padding: 0 0.5em;\n  color: #000000;\n  opacity: 0.6;\n  -webkit-transition: opacity 0.3s ease-out;\n  -o-transition: opacity 0.3s ease-out;\n  transition: opacity 0.3s ease-out; }\n  .SocialLink__social-icon__1HaNw:hover {\n    color: #000000;\n    opacity: 1; }\n", ""]);

// exports
exports.locals = {
	"social-icon": "SocialLink__social-icon__1HaNw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/components/atoms/SocialLink/SocialLink.scss
// module id = 188
// module chunks = 0